import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { ReportInterval } from '@nucleus-commerce/api-client/admin';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

export function salesReportQueryOptions(
  storeId: string,
  { from, to }: DayRange,
  interval: ReportInterval,
) {
  return queryOptions({
    queryKey: reportKeys.sales(storeId, { from, to }, interval),
    queryFn: () => reportsApi.sales(storeId, { from, to }, interval),
    placeholderData: keepPreviousData,
  });
}

export function useSalesReport(storeId: string, range: DayRange, interval: ReportInterval) {
  return useQuery(salesReportQueryOptions(storeId, range, interval));
}
